import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { ReducedParams } from '@api/order-reporting/types/ReducedParams';
import { ReducedOrdersReport } from '@api/order-reporting/types/ReducedOrdersReport';
import { ReducedGridData } from '@pages/reporting-pages/reduced-orders/types/ReducedGridData';
import { convertToGridData } from '@pages/reporting-pages/reduced-orders/store/convertors';
import { ShowReasonColumn } from '@pages/reporting-pages/ShowReasonColumn';
import { DateRange } from '@project-types/DateRange';



interface ReportingReducedState {
	gridData: ReducedGridData[] | null,
	dateRange: DateRange | null,
	selectedPlant: string | null,
	orderPhase: string | null,
	showReasonColumn: ShowReasonColumn,
};

const initialState: ReportingReducedState = {
	gridData: null,
	dateRange: null,
	selectedPlant: null,
	orderPhase: null,
	showReasonColumn: ShowReasonColumn.planning,
};



export const reportingReducedSlice = createSlice({
	name: 'reportingReduced',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<ReducedOrdersReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSelectedPlant: (state, action: PayloadAction<string | null>) => {
			state.selectedPlant = action.payload;
		},
		setOrderPhase: (state, action: PayloadAction<string | null>) => {
			state.orderPhase = action.payload;
		},
		setShowReasonColumn: (state, action: PayloadAction<ShowReasonColumn>) => {
			state.showReasonColumn = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<ReducedParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
			if (action.payload.dc !== state.selectedPlant) {
				state.selectedPlant = action.payload.dc ? action.payload.dc : null;
			}
			if (action.payload.orderPhase !== state.orderPhase) {
				state.orderPhase = action.payload.orderPhase ? action.payload.orderPhase : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSelectedPlant,
	setOrderPhase,
	setShowReasonColumn,
	setSearchParameters,
	resetStore } = reportingReducedSlice.actions;